/**
 * @file: useAudioPlaybackInSilentMode.ts
 * @copyright: (c) 2019-2026 sichuan zhichetech co., ltd.
 */

import {
  disableAudioPlaybackInSilentMode,
  enableAudioPlaybackInSilentMode,
} from '@euler/lib/audio';
import { useEffect } from 'react';

/**
 * While `enabled` is true, configures expo-av to play audio even when the
 * iPhone ringer switch is silenced. Reverts on unmount or when the flag
 * flips back to false. Reference-counted under the hood, so multiple
 * components can opt in concurrently without clobbering each other.
 */
export const useAudioPlaybackInSilentMode = (enabled: boolean) => {
  useEffect(() => {
    if (!enabled) return;
    void enableAudioPlaybackInSilentMode();
    return () => {
      void disableAudioPlaybackInSilentMode();
    };
  }, [enabled]);
};
